import { useSelector } from "react-redux";
import { EquipoVentas } from "../../../types/vendedor";
import { EquipoDisponibleItem } from "./EquipoDisponibleItem";
import { EquipoVentaContainer } from "./VendedoresList";
import { selectEquiposDisponibles } from "../../../store/equiposVentaSlice";

interface Props {
    equiposDisponibles?: EquipoVentas[];
}

export function EquiposDisponibles({ equiposDisponibles }: Props) {
    const equipos = useSelector(selectEquiposDisponibles);

    return (
        <div className="border-2s border-blue-400 rounded-md overflow-y-auto flex flex-col gap-y-2">
            {equipos == undefined
            ? <p className="text-center font-semibold text-gray-600 text-sm">No hay equipos</p>
            :
            <>
            {equipos.map((equipo, index) => (
            <EquipoDisponibleItem
                key={index}
                equpoIndex={index}
                equipo={equipo}/>
            ))
            }
            </>
            }
        </div>
    );
}
